module.exports = __webpack_public_path__ + "img/very_high_income.8f6d7ce4.svg";